import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
})
export class PrivacyComponent implements OnInit {
  public currentLanguageCode: string;

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.currentLanguageCode = this.translate.getBrowserLang();
  }
}